// // Polyfills
// // (these modules are what are in '@angular/bundles/angular2-polyfills' so don't use that here)
//
// // import 'ie-shim'; // Internet Explorer
// // import 'es6-promise';
// // import 'es7-reflect-metadata';
//
// // Prefer CoreJS over the polyfills above
// import 'core-js';
// import {isServer} from "./common/utils/node.utils";
require('zone.js');
//
// if ('production' === ENV) {
// 	// Production
//
//
// } else {
// 	// Development
//
// 	Error.stackTraceLimit = Infinity;
//
// 	require('zone.js/dist/long-stack-trace-zone');
//
// }
//
//
// import '@angular/localize/init';
//
//
(<any>window["global"]) = <any>window;

// added to avoid the error:
// Angular 9 introduced a global `$localize()` function that needs to be loaded.
// 	Please run `ng add @angular/localize` from the Angular CLI.
// (For non-CLI projects, add `import '@angular/localize/init';` to your `polyfills.ts` file.
// 	For server-side rendering applications add the import to your `main.server.ts` file.)
import '@angular/localize/init';
